// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhn_ss","PhotoTitleEditForm__cancelBtn":"iy_b bhn_sw bhn_sv"};